import { EventQBus, Toggle } from '../types/global';
import { ContentTracking } from './ContentTracking';

export class Tracking {
    private readonly eventQBus: EventQBus;
    private readonly toggle: Toggle;
    public visibilityTracked = false;
    private variationId: number | 'missing' = 'missing';
    private eventMergeId: number | undefined;

    //accessible for testing
    contentTracking: ContentTracking | null = null;

    constructor(eventQBus?: EventQBus | null, toggle?: Toggle | null) {
        this.eventQBus = eventQBus || o_global.eventQBus;
        this.toggle = toggle || o_util.toggle;
    }

    public init(): void {
        if (this.toggle.get('FT5_RICHCONTENT_FEATURE_902_TRACKING', false)) {
            this.registerVisibilityTrackingListener();

            this.eventQBus.on('ft5.richContent.variationChanged', ({ variationId, isInitialVariationChange }) => {
                const richContentElement = document.querySelector<HTMLElement>('.js_rc_component');
                if (richContentElement) {
                    this.contentTracking = new ContentTracking(this.eventQBus, richContentElement, variationId || 'missing');
                    if (isInitialVariationChange) {
                        this.contentTracking.trackPageImpression();
                    }
                } else {
                    this.contentTracking = null;
                }
            });
        } else {
            this.eventQBus.on('ft5.richContent.trackVariationChanged', ({ variationId, mergeId }) => {
                this.variationId = variationId;
                this.eventMergeId = mergeId;
                this.visibilityTracked = false;
                this.trackPageLoadedOld();
                this.trackRichContentVisibleIfRequiredOld();
                this.registerVisibilityTrackingOld();
            });
        }
    }

    private registerVisibilityTrackingListener(): void {
        const relevantEvents = ['scroll', 'resize'];
        relevantEvents.forEach(type => {
            addEventListener(type, () => this.contentTracking?.trackRichContentVisibleIfRequired(), false);
        });
    }

    private trackPageLoadedOld(): void {
        const dataContainer = {
            product_DetailInformation: 'richcontent',
            product_DetailInformationActivity: 'loaded',
            product_RichContentProvider: Tracking.getProviderListOld()
        };

        if (this.eventMergeId) {
            this.eventQBus.emit('tracking.bct.addToEvent', dataContainer, this.eventMergeId);
        } else {
            this.eventQBus.emit('tracking.bct.addToPageImpression', dataContainer);
        }
    }

    private registerVisibilityTrackingOld(): void {
        const relevantEvents = ['scroll', 'resize'];
        relevantEvents.forEach(type => {
            addEventListener(type, () => this.trackRichContentVisibleIfRequiredOld(), false);
        });
    }

    private trackRichContentVisibleIfRequiredOld(): void {
        if (!this.visibilityTracked && Tracking.isRichContentVisible()) {
            this.trackRichContentVisible();
            this.visibilityTracked = true;
        }
    }

    private static isRichContentVisible(): boolean {
        const dataContainer = document.querySelector<HTMLElement>('.js_rc_component');
        if (!dataContainer) {
            return false;
        }
        const contentContainerTop = dataContainer?.getBoundingClientRect().top;
        // if a div is invisible, the bounding client rect is always {0, 0, 0, 0}
        if (0 === contentContainerTop) {
            return false;
        }
        const viewportHeight = document.documentElement.clientHeight;
        const visibleHeight = viewportHeight - contentContainerTop;
        return visibleHeight > 100;
    }

    public trackRichContentVisible(): void {
        const variationId = this.variationId;
        this.eventQBus.emit('tracking.bct.submitEvent', {
            product_DetailInformation: 'richcontent',
            product_DetailInformationActivity: 'visible',
            product_RichContentProvider: Tracking.getProviderListOld(),
            product_VariationId: variationId || 'missing'
        });
    }

    private static getProviderListOld(): string {
        const dataContainer = document.querySelector<HTMLElement>('.js_rc_component');
        const providerList = dataContainer?.getAttribute('data-provider-list-a2b');
        return providerList || 'missing';
    }
}